import styled from 'styled-components';

const Canvas = styled.div`
    margin: 1.5em 3em 10em;
`;

export default Canvas;
